export default (theme, spacing) => ({
  defaultProps: {
    underline: "none",
  },
});
